export const SystemErrors = {
    Authentication:{
        NotFound: 404,
        TokenExpired: 401,
        Success:200,
    }
}